<template>
	<header-block :title="documentName" />
	<div v-if="documentUrl" class="documentViewPage">
		<div ref="panzoomContainer" class="panzoom-container">
			<VuePdfEmbed v-if="isPdf" :source="documentUrl" @rendered="initPanzoom" />
			<img v-else :src="documentUrl" :alt="documentName" class="doc-image" @load="initPanzoom" />
		</div>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import VuePdfEmbed from 'vue-pdf-embed';
import panzoom from 'panzoom';

export default {
	mixins: [Services],
	components: { HeaderBlock, VuePdfEmbed },
	data() {
		return {
			documentUrl: null,
			documentName: 'Document',
			isPdf: true,
			panzoomInstance: null,
		}
	},
	methods: {
		initPanzoom() {
			if (this.panzoomInstance) return;
			this.$nextTick(() => {
				const container = this.$refs.panzoomContainer;
				let isZoomed = false;
				const instance = panzoom(container, {
					maxZoom: 5,
					minZoom: 1,
					smoothScroll: true,
					bounds: true,
					boundsPadding: 1,
					onTouch: (e) => {
						// Only allow single-finger drag (pan) when zoomed in
						if (e.touches && e.touches.length === 1 && !isZoomed) {
							return false;
						}
						return true;
					},
				});
				instance.on('zoom', () => {
					isZoomed = instance.getTransform().scale > 1.05;
				});
				this.panzoomInstance = instance;
			});
		}
	},
	mounted() {
		const id = this.$route.params.id;
		this._getDocument(id, (doc) => {
			this.documentUrl = doc.url;
			this.documentName = doc.documentName || doc.name || 'Document';
			this.isPdf = doc.isPdf !== false;
		});
	},
	beforeUnmount() {
		if (this.panzoomInstance) {
			this.panzoomInstance.dispose();
		}
	}
}
</script>

<style scoped>
.documentViewPage {
	padding: 0;
}

.panzoom-container {
	transform-origin: 0 0;
}

.doc-image {
	width: 100%;
	display: block;
}
</style>
